import { Skeleton } from '../../../Skeleton'

import { CALENDAR_GRID_DAY_POPOVER_SKELETON_ROWS_LENGTH } from './CalendarGridDayPopoverSkeleton.constants'

import * as styles from './CalendarGridDayPopoverSkeleton.module.css'

function CalendarGridDayPopoverSkeleton({
  rowsLength = CALENDAR_GRID_DAY_POPOVER_SKELETON_ROWS_LENGTH,
}) {
  return (
    <div className={styles.CalendarGridDayPopoverSkeleton}>
      {Array.from({ length: rowsLength }).map((_, index) => (
        <Skeleton className={styles.row} key={index} />
      ))}
    </div>
  )
}

export default CalendarGridDayPopoverSkeleton
